import { Injectable, OnDestroy } from '@angular/core';
import { CONFIG } from 'app/config/config';
import { Router, NavigationEnd } from '@angular/router';

declare var systemAnalytics;
declare var appAnalytics;

@Injectable()
export class AnalyticsService implements OnDestroy {
  previousAppTrackingID: string;
  userID: number;
  subscriptions: any[] = [];

  constructor(private _router: Router) { }
  createAnalytics(name: string) {
    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*<any>new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script','https://www.google-analytics.com/analytics.js', name);
  }

  initializeSystemAnalytics(userID: number) {
    this.userID = userID;
    this.createAnalytics('systemAnalytics');
    window['systemAnalytics']('create', CONFIG.ANALYTICS_TRACKING_ID, 'auto');
    window['systemAnalytics']('set', 'userId', this.userID); // Set the user ID using signed-in user_id.

    this.subscriptions.push(this._router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.trackPageView(e.url);
      }
    }));
  }

  initializeAppAnalytics(trackingID: string) {
    if (!this.previousAppTrackingID || this.previousAppTrackingID !== trackingID) {
      this.clearAppAnalytics();
      if (trackingID && this.userID) {
        this.previousAppTrackingID = trackingID;
        this.createAnalytics('appAnalytics');
        window['appAnalytics']('create', trackingID, 'auto');
        window['appAnalytics']('set', 'userId', this.userID); // Set the user ID using signed-in user_id.
        this.trackPageView(this._router.url);
      }
    }
  }

  clearAppAnalytics() {
    if (window['appAnalytics']) window['appAnalytics']('send', 'pageview', {'sessionControl': 'end'});
    this.previousAppTrackingID = null;
    window['appAnalytics'] = null;
  }

  trackPageView(url: string) {
    if (window['systemAnalytics']) systemAnalytics('send', 'pageview', url);
    if (window['appAnalytics']) appAnalytics('send', 'pageview', url);
  }

  trackPushNotification() {
    if (window['systemAnalytics']) systemAnalytics('send', 'event', 'Push', 'Sent');
    if (window['appAnalytics']) appAnalytics('send', 'event', 'Push', 'Sent');
  }

  clearAnalytics() {
    this.userID = null;
    window['systemAnalytics'] = null;
    window['appAnalytics'] = null;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      if (subscription) subscription.unsubscribe();
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/analytics/analytics.service.ts